<template>
    <!-- 开红包动画弹窗 S -->
    <!-- 交互：
        1.点击“开” 在d.phone-content 添加.ani-redbag
        2. 动画播放结束 移除当前的.phone-content -->
    <!--<div :class="['layout-column layout-align-center-center', isOpenRedbag ? 'ani-redbag' : '']" @click="openRedbag">-->
     <div class="layout-column layout-align-center-center ani-redbag" @click="openRedbag" ref="redbag">
        <div class="phone-content current">
        <div class="screen-outer">
            <div class="ele screen-outer-up-wrap">
                <div class="ele screen-outer-hand-up"></div>
            </div>
            <div class="ele screen-outer-down-wrap">
                <div class="ele screen-outer-hand-down"></div>
            </div>
        </div>
    </div>
    </div>
    <!-- 开红包动画弹窗 E -->
</template>
<script lang="js">
    export default {
      data() {
        return {
        };
      },
      props: {
      },
      methods: {
        openRedbag() {
          let self = this;
          self.isOpenRedbag = true;
          setTimeout(() => {
            // self.$router.replace('/getreward');
            // this.$router.push({ path: '/getreward', query: { _from: 'wzq' }, replace: true });
            this.$router.push({path: '/getreward', params: {_from: 'wzq'}, query: {_from: 'wzq'}, replace: true})
          }, 1000);
        }
      },
      mounted() {
        // let self = this;
        // setTimeout(() => {
        //   self.$refs.redbag.remove();
        //   self.$router.replace('/getreward');
        // }, 1000);
      }
    }
</script>
<style></style>
